<template>
  <zm-drawer
    :visible="visible"
    :title="title"
    :footer="footer"
    :width="'55%'"
    :placement="placement"
    @cancel="cancel"
    class="modal"
  >
    <div slot="drawerBody" class="drawerDiv">
      <top-search ref="topSearch" @search="search" @reset="reset" :delEquipmentType="delEquipmentType" :gasSearch="gasSearch"></top-search>
      <!--      分割线-->
      <div class="line"></div>
      <parameter-screening ref="parameterScreening"></parameter-screening>
      <params-screening ref="paramsScreening"></params-screening>
      <feature-screening ref="featureScreening"></feature-screening>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button type="primary" :style="{ marginRight: '8px' }" @click="topSearch">
          查询
        </a-button>
        <a-button @click="topReset">
          重置
        </a-button>
      </div>
    </div>
  </zm-drawer>
</template>

<script>
import topSearch from './modules/topSearch'
import ParameterScreening from '@/views/equipmentLedger/modules/searchModel/modules/parameterScreening.vue'
import FeatureScreening from '@/views/equipmentLedger/modules/searchModel/modules/featureScreening.vue'
import ParamsScreening from '@/views/equipmentLedger/modules/searchModel/modules/paramsScreening.vue'
export default {
  name: 'SearchModel',
  components: {
    FeatureScreening,
    ParameterScreening,
    ParamsScreening,
    topSearch
  },
  props: {
    delEquipmentType: {
      type: Boolean,
      default: true
    },
    gasSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: '详细查询',
      footer: false,
      placement: 'right',
      visible: false
    }
  },
  created () {

  },
  methods: {
    open (visible) {
      this.visible = visible
    },
    setSearchModel (searchModel) {
      console.log(searchModel)
      this.$nextTick(() => {
        delete searchModel.subcompanyid
        delete searchModel.pageNum
        delete searchModel.pageSize
        delete searchModel.total
        delete searchModel.pageSizeOptions
        delete searchModel.showSizeChanger
        delete searchModel.showQuickJumper
        delete searchModel.current
        delete searchModel.pid
        delete searchModel.subcompanyid
        if (this.delEquipmentType) {
          delete searchModel.equipmentType
        }
        this.$refs.topSearch.setSearchModel(searchModel)
      })
    },
    topSearch () {
      this.$refs.topSearch.search(false)
    },
    topReset () {
      this.$refs.topSearch.reset()
    },
    // 详细查询
    async search (searchModel, notSearch, list) {
      const params1 = this.$refs.parameterScreening.getParamQuery()
      const params2 = this.$refs.paramsScreening.getParamQuery()
      const params3 = this.$refs.featureScreening.getParamQuery()
      if (params1 === false || params2 === false || params3 === false) {
        return
      }
      let searchNum = params1.length + params2.length + params3.length
      searchModel.strParamQuery = params1.length > 0 ? JSON.stringify(params1) : ''
      if (params2.length > 0) {
        searchModel.fieldQuery = params2
      } else {
        delete searchModel.fieldQuery
      }
      if (params3.length > 0) {
        searchModel.peculiarityQuery = params3
      } else {
        delete searchModel.peculiarityQuery
      }
      searchModel.delpid = false
      if (!this.delEquipmentType) {
        for (const item in searchModel) {
          if (item !== 'delpid') {
            if (item === 'equipmentType') {
              if (searchModel[item] !== '1800000000') {
                searchNum++
                searchModel.delpid = true
              }
            } else {
              if ((!searchModel[item] || searchModel[item].length === 0)) {
                if (item === 'isYlrqPeculiarity' || item === 'isHbPeculiarity' || item === 'isTzsbPeculiarity') {
                  if (searchModel[item] !== 0 && searchModel[item] !== 1) {
                    delete searchModel[item]
                  } else {
                    searchNum++
                  }
                } else {
                  delete searchModel[item]
                }
              } else {
                searchNum++
                if (item === 'entryDate' || item === 'retirementDate' || item === 'usedeptid' || item === 'strParamQuery' || item === 'fieldQuery' || item === 'peculiarityQuery') {
                  searchNum--
                }
                searchModel.delpid = true
              }
            }
          }
        }
        if (list) {
          this.$emit('retrievesTheTableHeader', [searchModel.equipmentType], true, searchModel, searchNum, notSearch)
        } else {
          this.$emit('setSearchCondition', searchModel, true, searchNum, notSearch)
        }
      } else {
        for (const item in searchModel) {
          if (item !== 'delpid') {
            if ((!searchModel[item] || searchModel[item].length === 0)) {
              if (item === 'isYlrqPeculiarity' || item === 'isHbPeculiarity' || item === 'isTzsbPeculiarity') {
                if (searchModel[item] !== 0 && searchModel[item] !== 1) {
                  delete searchModel[item]
                } else {
                  searchNum++
                }
              } else {
                delete searchModel[item]
              }
            } else {
              searchNum++
              if (item === 'entryDate' || item === 'retirementDate' || item === 'usedeptid' || item === 'strParamQuery' || item === 'fieldQuery' || item === 'peculiarityQuery') {
                searchNum--
              }
              searchModel.delpid = true
            }
          }
        }
        this.$emit('setSearchCondition', searchModel, true, searchNum, notSearch)
      }
      this.open(false)
    },
    reset (searchModel) {
      this.$refs.parameterScreening.reset()
      this.$refs.paramsScreening.reset()
      this.$refs.featureScreening.reset()
      this.$emit('setSearchCondition', searchModel, true, 0, true)
      // this.$emit('reset')
    },
    cancel () {
      this.$refs.topSearch.search(true)
    }
  }
}
</script>

<style lang="less" scoped>
.drawerDiv {
  padding-right: 5px;
  padding-bottom: 53px;
}
.line {
  height: 1px;
  margin: 16px 0;
  background-color: #DDDDDD;
}
</style>
